var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('Breadcrumb',{attrs:{"breadcrumb_link":_vm.notice_breadcrumb}}),_c('BoardArticleList',{attrs:{"board-info-id":_vm.boardInfoId,"board-article-read-link":"/p/NoticeRead/"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }